import React from 'react'
import { css, withTheme } from 'styled-components'
import { Box, Card } from 'rebass'
import PropTypes from 'prop-types'
import LogoSvg from './logo'
import MenuIcon from '../../images/menu.svg'
import CloseIcon from '../../images/close.svg'

export const Wrapper = ({ children }) => (
  <Box
    css={css`
      position: fixed;
      pointer-events: none;
      z-index: 10;
      bottom: 0;
      left: 0;
      right: 0;
      line-height: 1;
    `}
  >
    {children}
  </Box>
)

Wrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export const FoldOut = ({ children }) => (
  <Box
    pt="5"
    pb="180px"
    css={css`
      background: white;
      width: 100vw;
      height: 100vh;
      position: fixed;
      top: 0;
      overflow: hidden;
      overflow-y: auto;
      text-align: center;
      z-index: 9;
    `}
  >
    {children}
  </Box>
)

FoldOut.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}
export const Logo = withTheme(({ theme, invert, ...rest }) => (
  <Box
    fontSize={[4, 5]}
    css={css`
      width: 4em;
      margin: 0 0 1em 1em;
    `}
  >
    <LogoSvg color={invert ? '#FFFFFF' : theme.colors.red} {...rest} />
  </Box>
))

Logo.propTypes = {
  src: PropTypes.string.isRequired,
}

export const MenuToggle = ({ isOpen, onClick }) => (
  <Card
    onClick={onClick}
    fontSize={[4, 5]}
    bg="white"
    backgroundImage={`url(${isOpen ? CloseIcon : MenuIcon})`}
    backgroundSize="80%"
    backgroundPosition="center center"
    backgroundRepeat="no-repeat"
    css={css`
      pointer-events: auto;
      content: '';
      width: 2em;
      height: 2em;
      border-radius: 2em;
      position: fixed;
      bottom: 1em;
      right: 1em;
      cursor: pointer;
      fill: red;
    `}
  />
)

MenuToggle.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}
